/* THRIFT AVE — cart drawer v2 (16/09/2026)
 * Discount code applied IN the cart (Ajax API) instead of Shrine's redirect to
 * /checkout?discount=CODE. The drawer re-renders through the theme's own
 * cart-drawer.renderContents(state, skipOpen) so the summary, the gift blocks
 * and the header bubble stay in sync. Delegated listeners: they survive every
 * re-render of #CartDrawer. Also handles the accordion on /cart (page reload).
 */
(function () {
  'use strict';
  if (window.__taCartDrawer) return;
  window.__taCartDrawer = true;

  var busy = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function json(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function update(discountList) {
    return json(root() + 'cart/update.js', {
      discount: discountList.join(','),
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    });
  }

  function render(state) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && state && state.sections) {
      drawer.renderContents(state, true);
    }
    /* NO publish(PUB_SUB_EVENTS.cartUpdate) here: Shrine's cart-drawer-items answers it by
       fetching /cart?section_id=main-cart-items and injecting the cart PAGE markup into the
       drawer (theme bug, harmless for the theme only because its own publish happens before
       renderContents swaps the element). Our custom event is enough for <ta-addon>. */
    try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state, source: 'ta-cart-discount' } })); } catch (e) {}
  }

  function currentCodes(state) {
    var out = [];
    ((state && state.discount_codes) || []).forEach(function (d) {
      if (d && d.code && d.applicable !== false) out.push(String(d.code));
    });
    return out;
  }

  function showMessage(box, text, tone) {
    var msg = box.querySelector('[data-ta-discount-msg]');
    if (!msg) return;
    msg.textContent = text || '';
    if (tone) msg.setAttribute('data-tone', tone); else msg.removeAttribute('data-tone');
  }

  /* After a re-render the <details> comes back closed (fresh HTML): reopen it and
     show the outcome, so the customer sees the chip or the error where they typed. */
  function afterRender(text, tone, code) {
    var box = document.querySelector('cart-drawer [data-ta-discount]') || document.querySelector('[data-ta-discount]');
    if (!box) return;
    box.open = true;
    showMessage(box, text, tone);
    if (tone !== 'ok') {
      var input = box.querySelector('input[name="discount"]');
      if (input) { input.value = code || ''; input.focus(); }
    }
  }

  function setBusy(box, on) {
    busy = on;
    var btn = box.querySelector('.ta-discount__btn');
    if (btn) { if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy'); }
  }

  function onCartPage() {
    return !!document.querySelector('cart-items, .cart-items-container, #main-cart-items') && !document.querySelector('cart-drawer.active');
  }

  function apply(box, code) {
    if (busy) return;
    var normalized = code.trim().toUpperCase();
    if (!normalized) { showMessage(box, box.getAttribute('data-msg-error'), 'error'); return; }
    setBusy(box, true);
    showMessage(box, '');
    var applied = Array.prototype.map.call(box.querySelectorAll('.ta-discount__chip'), function (c) { return c.getAttribute('data-code'); });
    if (applied.indexOf(normalized) === -1) applied.push(normalized);
    update(applied).then(function (state) {
      var entry = ((state && state.discount_codes) || []).filter(function (d) { return d && String(d.code).toUpperCase() === normalized; })[0];
      if (entry && entry.applicable) {
        if (onCartPage()) { window.location.reload(); return; }
        render(state);
        afterRender(box.getAttribute('data-msg-ok'), 'ok', normalized);
        return;
      }
      /* invalid or not applicable: drop it so Shopify does not keep a dead code on the cart */
      var keep = currentCodes(state).filter(function (c) { return c.toUpperCase() !== normalized; });
      return update(keep).then(function (clean) {
        if (onCartPage()) { setBusy(box, false); showMessage(box, box.getAttribute(entry ? 'data-msg-not-applicable' : 'data-msg-error'), 'error'); return; }
        render(clean);
        afterRender(box.getAttribute(entry ? 'data-msg-not-applicable' : 'data-msg-error'), 'error', normalized);
      });
    }).catch(function () {
      showMessage(box, box.getAttribute('data-msg-error'), 'error');
    }).then(function () {
      var fresh = document.querySelector('[data-ta-discount]');
      if (fresh) setBusy(fresh, false); else busy = false;
    });
  }

  function remove(box, code) {
    if (busy) return;
    setBusy(box, true);
    var keep = Array.prototype.map.call(box.querySelectorAll('.ta-discount__chip'), function (c) { return c.getAttribute('data-code'); })
      .filter(function (c) { return c !== code; });
    update(keep).then(function (state) {
      if (onCartPage()) { window.location.reload(); return; }
      render(state);
      var fresh = document.querySelector('[data-ta-discount]');
      if (fresh) fresh.open = true;
    }).catch(function () {
      showMessage(box, box.getAttribute('data-msg-error'), 'error');
    }).then(function () {
      var fresh = document.querySelector('[data-ta-discount]');
      if (fresh) setBusy(fresh, false); else busy = false;
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('[data-ta-discount-form]');
    if (!form) return;
    e.preventDefault();
    var box = form.closest('[data-ta-discount]');
    var input = form.querySelector('input[name="discount"]');
    if (box && input) apply(box, input.value);
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-ta-discount-remove]');
    if (!btn) return;
    e.preventDefault();
    var chip = btn.closest('.ta-discount__chip');
    var box = btn.closest('[data-ta-discount]');
    if (chip && box) remove(box, chip.getAttribute('data-code'));
  });

  /* Enter inside the input must not bubble to the cart form (#CartDrawer-Form → checkout). */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.code !== 'Enter' && e.keyCode !== 13) return;
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-ta-discount-form] input')) return;
    e.preventDefault();
    var form = input.closest('[data-ta-discount-form]');
    if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }, true);
})();
